/* eslint-disable import/prefer-default-export */
import moize from 'moize';
import { reduxForm } from 'redux-form';
export const connectForm = moize((form, defaultValues, Component) => reduxForm({
    form,
    initialValues: { value: defaultValues },
    enableReinitialize: true,
    destroyOnUnmount: false,
})(Component));
